// Mock data for AvantiTutor clone

// Logo URL - dein eigenes AvantiTutor Logo
export const LOGO_URL = 'https://customer-assets-rejwkqb3.emergentagent.net/job_tutor-platform-23/artifacts/lndmc6zl_Screenshot%202026-08-07%20124953.png';

// Corporate Contact Info (aus Flyer)
export const CONTACT = {
  website: 'www.avantitutor.com',
  phone: '+49 15511 527700',
  phoneRaw: '+4915511527700',
  whatsapp: 'https://wa.me/4915511527700',
  email: 'info@avantitutor.com',
  address: 'Holunderweg 9A, 79790 Küssaberg',
  instagram: 'https://instagram.com/avantitutor',
  tagline: 'LERNEN. VERSTEHEN. WEITERKOMMEN.',
  mode: 'NUR ONLINE',
};

export const navLinks = [
  { label: 'Startseite', path: '/' },
  { label: 'Unser Ansatz', path: '/#ansatz' },
  { label: 'Fächer', path: '/faecher' },
  { label: 'Preise', path: '/#preise' },
  { label: 'FAQ', path: '/faq' },
  { label: 'Blog', path: '/blog' },
  { label: 'Kontakt', path: '/kontakt' },
];

export const heroStats = [
  { icon: 'Star', text: '4.9/5 Bewertung' },
  { icon: 'GraduationCap', text: '120+ betreute Schüler' },
  { icon: 'MapPin', text: 'Online & vor Ort' },
];

export const painProblems = [
  'Schlechte Noten trotz Lernen',
  'Prüfungsangst & Blackouts',
  'Fehlende Struktur beim Lernen',
  'Auswendig statt verstehen',
  'Demotivation und Selbstzweifel',
  'Last-Minute-Lernen vor Klausuren',
];

export const ourSolutions = [
  'Individuelle Bedarfsanalyse',
  'Strukturierter Förderplan',
  'Persönlicher Lerncoach',
  'Verstehen statt Pauken',
  'Stärkung von Selbstvertrauen',
  'Regelmäßige Fortschritts-Reports',
];

export const painPoints = [
  {
    icon: 'BookOpen',
    title: 'Fehlende Struktur',
    text: 'Viel Lernen, aber ohne Plan – die Ergebnisse bleiben trotzdem aus.',
  },
  {
    icon: 'Brain',
    title: 'Falsche Methode',
    text: 'Auswendiglernen statt verstehen – und bei jeder Arbeit geht das Chaos von vorne los.',
  },
  {
    icon: 'HeartPulse',
    title: 'Unsicherheit & Stress',
    text: 'Prüfungsangst, Selbstzweifel und das Gefühl, nie genug zu tun.',
  },
  {
    icon: 'Clock',
    title: 'Zeitdruck vor Klausuren',
    text: 'Last-Minute Lernen bringt selten stabile Noten – wir setzen früher an.',
  },
];

export const approachSteps = [
  {
    step: '01',
    title: 'Bedarfsanalyse',
    text: 'Gemeinsam identifizieren wir Stärken, Lernlücken und Ziele – ehrlich und klar.',
  },
  {
    step: '02',
    title: 'Förderplan',
    text: 'Ein strukturierter, individueller Plan statt wahlloser Nachhilfestunden.',
  },
  {
    step: '03',
    title: 'Lernsessions',
    text: 'Persönlich, online oder hybrid – fokussiert auf Verständnis statt Pauken.',
  },
  {
    step: '04',
    title: 'Fortschrittskontrolle',
    text: 'Regelmäßiges Feedback an Eltern, messbarer Erfolg in Schule & Uni.',
  },
];

export const STAGES = [
  { id: 'grund',  label: 'Grundschule', short: 'GS' },
  { id: 'mittel', label: 'Mittelstufe', short: 'MS' },
  { id: 'ober',   label: 'Oberstufe',   short: 'OS' },
  { id: 'uni',    label: 'Uni',         short: 'Uni' },
];

const stageText = (ids) => ids.map((id) => STAGES.find((s) => s.id === id).label).join(', ');
const subj = (icon, name, stages, color, lk = false) => ({ icon, name, stages, lk, color, levels: stageText(stages) });

// Quelle: AvantiTutor_Faecherliste.xlsx – lk = Leistungskurs-Nachhilfe (Oberstufe) verfügbar
export const subjects = [
  subj('Calculator',   'Mathematik',              ['grund', 'mittel', 'ober', 'uni'], 'from-teal-400 to-cyan-500', true),
  subj('BookText',     'Deutsch',                 ['grund', 'mittel', 'ober'],        'from-sky-400 to-blue-500', true),
  subj('Languages',    'Englisch',                ['grund', 'mittel', 'ober'],        'from-cyan-400 to-teal-500', true),
  subj('Globe2',       'Französisch',             ['grund', 'mittel', 'ober'],        'from-blue-400 to-indigo-500', true),
  subj('Atom',         'Physik',                  ['mittel', 'ober'],                 'from-indigo-400 to-blue-500', true),
  subj('FlaskConical', 'Chemie',                  ['mittel', 'ober'],                 'from-teal-500 to-emerald-500'),
  subj('Dna',          'Biologie',                ['mittel', 'ober'],                 'from-emerald-400 to-teal-500'),
  subj('Landmark',     'Geschichte',              ['mittel', 'ober'],                 'from-slate-500 to-slate-700'),
  subj('Map',          'Geografie / Erdkunde',    ['mittel', 'ober'],                 'from-cyan-500 to-sky-600'),
  subj('LineChart',    'Wirtschaft',              ['mittel', 'ober'],                 'from-blue-500 to-cyan-600'),
  subj('Leaf',         'Sachunterricht',          ['grund'],                          'from-emerald-400 to-green-500'),
  subj('PenLine',      'Lesen & Schreiben',       ['grund'],                          'from-sky-400 to-cyan-500'),
  subj('SpellCheck',   'Rechtschreibung',         ['grund'],                          'from-teal-400 to-blue-500'),
  subj('Briefcase',    'BWL',                     ['uni'],                            'from-blue-600 to-indigo-600'),
  subj('TrendingUp',   'Wirtschaftswissenschaften', ['uni'],                          'from-cyan-600 to-blue-700'),
  subj('Cog',          'Technische Mechanik',     ['uni'],                            'from-slate-600 to-blue-800'),
  subj('Building2',    'Statik',                  ['uni'],                            'from-blue-700 to-slate-800'),
  subj('Wrench',       'Ingenieurwesen',          ['uni'],                            'from-teal-600 to-blue-800'),
];

// Preisliste (AvantiTutor_Preisliste.xlsx): Basis ist der 45-Min-Preis, 60/90 Min proportional & abgerundet
export const DURATIONS = [45, 60, 90];
export const price45 = (name, stage, lk = false) => {
  if (stage === 'grund') return name === 'Mathematik' ? 25 : 24;
  if (stage === 'mittel') return ['Mathematik', 'Physik'].includes(name) ? 30 : 28;
  if (stage === 'ober') return lk ? 32 : 30;
  if (stage === 'uni') return 35;
  return null;
};
export const priceFor = (p45, minutes) => (p45 == null ? null : Math.floor((p45 * minutes) / 45));
export const minPrice45 = (s) => {
  const list = s.stages.map((st) => price45(s.name, st, s.lk)).filter((p) => p != null);
  return list.length ? Math.min(...list) : null;
};
export const testimonials = [
  {
    name: 'Laura K.',
    role: 'Schülerin, 11. Klasse',
    text: 'Nach drei Monaten bei AvantiTutor bin ich in Mathe von 4 auf 2 gekommen. Endlich verstehe ich, warum Dinge funktionieren – nicht nur wie.',
    rating: 5,
    initials: 'LK',
  },
  {
    name: 'Familie Hoffmann',
    role: 'Eltern aus Stuttgart',
    text: 'Der strukturierte Förderplan hat unserem Sohn echt geholfen. Die regelmäßigen Rückmeldungen geben uns als Eltern Sicherheit.',
    rating: 5,
    initials: 'FH',
  },
  {
    name: 'Jonas M.',
    role: 'Student, BWL',
    text: 'Habe meine Statistik-Klausur mit 1,3 bestanden. Die Intensivsessions vor der Prüfung waren Gold wert.',
    rating: 5,
    initials: 'JM',
  },
  {
    name: 'Sophie B.',
    role: 'Abiturientin',
    text: 'Ohne AvantiTutor hätte ich mein Abitur so nicht geschafft. Ehrlich, direkt und super motivierend.',
    rating: 5,
    initials: 'SB',
  },
];

// Quelle: AvantiTutor_FAQ.xlsx
export const faqCategories = [
  {
    id: 'start',
    label: "Start & Ablauf",
    icon: 'Rocket',
    items: [
      { q: "Wie läuft die kostenlose Bedarfsanalyse ab?", a: "Die Bedarfsanalyse ist der Ausgangspunkt unserer Nachhilfe. Wir schauen uns gemeinsam an, wo der Schüler aktuell steht, welche Themen bereits sicher sitzen und wo noch Lücken bestehen. Dazu führen wir einen kurzen Mini-Test bzw. einige passende Aufgaben durch. Die Ergebnisse und alle relevanten Informationen geben wir anschließend an den Tutor weiter, sodass dieser von Beginn an gezielt mit dem Schüler arbeiten kann." },
      { q: "Ist die Bedarfsanalyse wirklich kostenlos?", a: "Ja. Die Bedarfsanalyse ist vollständig kostenlos und unverbindlich. Erst wenn anschließend tatsächlich Nachhilfe in Anspruch genommen wird, entstehen Kosten." },
      { q: "Wie schnell kann die Nachhilfe starten?", a: "Direkt nach der Bedarfsanalyse. Unsere Tutoren sind bereits ausgewählt und startklar, sodass nicht erst nach einem passenden Nachhilfelehrer gesucht werden muss. Sobald die organisatorischen Details geklärt sind, kann die Nachhilfe unmittelbar beginnen." },
      { q: "Findet die Nachhilfe online oder vor Ort statt?", a: "AvantiTutor ist auf Online-Nachhilfe spezialisiert. Dadurch können wir Schülerinnen, Schüler und Studierende unabhängig vom Wohnort betreuen und ihnen passende Tutoren zur Verfügung stellen." },
      { q: "Wie funktioniert Online-Nachhilfe?", a: "Der Unterricht findet per Video statt. Aufgaben, Schulmaterialien, Arbeitsblätter und Skripte können digital geteilt und gemeinsam bearbeitet werden. Der Tutor kann Inhalte erklären, Aufgaben vorrechnen und Schritt für Schritt gemeinsam mit dem Schüler bearbeiten." },
      { q: "Welche Klassenstufen werden abgedeckt?", a: "Wir bieten Unterstützung von der Grundschule über Mittel- und Oberstufe bis hin zu Abitur, Ausbildung und Studium an." },
      { q: "Welche Fächer bietet AvantiTutor an?", a: "AvantiTutor bietet Nachhilfe in zahlreichen Schulfächern sowie ausgewählten Studienfächern an. Die verfügbaren Fächer und Stufen sind auf unserer Website übersichtlich aufgeführt." },
      { q: "Kann ich auch kurzfristig Hilfe vor einer Klassenarbeit oder Prüfung bekommen?", a: "Ja. Neben regelmäßiger Nachhilfe bieten wir auch gezielte Unterstützung vor Klassenarbeiten, Klausuren, Abschlussprüfungen oder anderen Prüfungen an." },
      { q: "Gibt es eine Probestunde?", a: "Wir arbeiten bewusst nicht mit einer klassischen Probestunde, sondern starten direkt mit der Nachhilfe. Tutor und Schüler benötigen erfahrungsgemäß ein bis zwei Einheiten, um sich kennenzulernen und optimal aufeinander einzustimmen. Unsere Tutoren werden sorgfältig ausgewählt und fachlich passend zugeordnet. Da es bei AvantiTutor keine langfristige Vertragsbindung und kein Abo-Modell gibt, bleibt der Einstieg trotzdem vollständig flexibel." },
      { q: "Was braucht man für den Online-Unterricht?", a: "Benötigt werden lediglich ein Laptop, PC oder Tablet mit stabiler Internetverbindung sowie Mikrofon und idealerweise eine Kamera. Schulunterlagen oder Aufgaben können vor der Stunde digital an den Tutor geschickt werden." },
    ],
  },
  {
    id: 'unterricht',
    label: "Unterricht, Tutoren & Lernerfolg",
    icon: 'GraduationCap',
    items: [
      { q: "Wie wird der passende Tutor ausgewählt?", a: "Wir berücksichtigen Fach, Klassenstufe, Lernziel, aktuellen Leistungsstand und die Anforderungen des Schülers. Durch die Bedarfsanalyse erhält der Tutor bereits vor der ersten Unterrichtseinheit wichtige Informationen über den aktuellen Stand und bestehende Wissenslücken." },
      { q: "Welche Qualifikationen haben die Tutoren?", a: "Unsere Tutoren verfügen über einen akademischen Hintergrund und werden sorgfältig ausgewählt. Bei uns unterrichten Studierende, Absolventinnen und Absolventen, erfahrene Nachhilfelehrer sowie Personen, die bereits selbst in der Lehre tätig sind. Neben der fachlichen Qualifikation achten wir besonders darauf, dass Inhalte verständlich und geduldig vermittelt werden können." },
      { q: "Was passiert, wenn die Chemie mit dem Tutor nicht stimmt?", a: "Eine gute Zusammenarbeit zwischen Tutor und Schüler ist für erfolgreiche Nachhilfe sehr wichtig. Sollte es menschlich einmal nicht passen, kann jederzeit unkompliziert ein Tutorwechsel organisiert werden." },
      { q: "Was passiert, wenn mein Tutor im Urlaub oder verhindert ist?", a: "Sollte ein Tutor beispielsweise wegen Urlaub, Krankheit oder aus anderen Gründen verhindert sein, können wir auf Wunsch eine Vertretung organisieren. So kann der Unterricht weiterlaufen und insbesondere vor Prüfungen entstehen möglichst keine unnötigen Unterbrechungen." },
      { q: "Ist der Unterricht individuell oder in Gruppen?", a: "Bei AvantiTutor findet der Unterricht grundsätzlich individuell statt. Wir setzen bewusst auf Einzelunterricht statt Gruppenunterricht, damit der Tutor vollständig auf das Lerntempo, die Fragen und die persönlichen Wissenslücken des Schülers eingehen kann." },
      { q: "Werden auch Hausaufgaben gemeinsam gemacht?", a: "Ja. Hausaufgaben können selbstverständlich gemeinsam bearbeitet werden. Unser Ziel ist allerdings nicht nur, Aufgaben zu lösen, sondern dem Schüler das zugrunde liegende Thema so zu erklären, dass ähnliche Aufgaben anschließend selbstständig gelöst werden können." },
      { q: "Kann der Tutor mit den aktuellen Schulunterlagen arbeiten?", a: "Ja. Lehrbuchseiten, Arbeitsblätter, Hausaufgaben, alte Klassenarbeiten, Klausuren oder Skripte können vorab geschickt und gezielt im Unterricht behandelt werden." },
      { q: "Wie läuft eine typische Nachhilfestunde ab?", a: "Die Stunde richtet sich individuell nach dem Schüler. Häufig werden zunächst offene Fragen geklärt, anschließend aktuelle Themen erklärt und passende Aufgaben gemeinsam bearbeitet. Der Tutor überprüft dabei regelmäßig, ob die Inhalte wirklich verstanden wurden." },
      { q: "Wird nur für die nächste Klassenarbeit gelernt oder auch langfristig?", a: "Beides. Vor einer Prüfung kann der Unterricht gezielt auf die anstehenden Themen ausgerichtet werden. Gleichzeitig möchten wir bestehende Wissenslücken langfristig schließen und ein stabiles fachliches Fundament aufbauen." },
      { q: "Kann AvantiTutor auch bei größeren Wissenslücken helfen?", a: "Ja. Genau dafür ist die Bedarfsanalyse besonders hilfreich. Wir erkennen, an welchen Grundlagen es fehlt, und können die Themen anschließend Schritt für Schritt und in sinnvoller Reihenfolge aufarbeiten." },
      { q: "Gibt es spezielle Vorbereitung auf Abitur oder Abschlussprüfungen?", a: "Ja. Der Unterricht kann gezielt auf Abitur, Abschlussprüfungen, Klausuren oder andere Prüfungsformate ausgerichtet werden. Dabei können sowohl fachliche Inhalte wiederholt als auch typische Prüfungsaufgaben trainiert werden." },
      { q: "Bietet ihr auch Nachhilfe für Studierende an?", a: "Ja. AvantiTutor bietet auch Unterstützung für Studierende in ausgewählten Hochschul- und Universitätsfächern an – beispielsweise zur Klausurvorbereitung, zum Aufarbeiten einzelner Themen oder begleitend während des Semesters." },
    ],
  },
  {
    id: 'eltern',
    label: "Eltern, Preise & Organisation",
    icon: 'Users',
    items: [
      { q: "Bekommen wir als Eltern Rückmeldung zum Fortschritt?", a: "Ja. Auf Wunsch erhalten Eltern Rückmeldung darüber, wie sich der Schüler entwickelt, welche Fortschritte gemacht wurden und bei welchen Themen noch Unterstützungsbedarf besteht." },
      { q: "Können Eltern mit dem Tutor oder AvantiTutor Rücksprache halten?", a: "Natürlich. Bei Fragen zum Lernfortschritt, zur Unterrichtsplanung oder zu organisatorischen Themen ist eine Rücksprache jederzeit möglich." },
      { q: "Wie lange dauert eine Nachhilfestunde?", a: "Unsere Preise basieren grundsätzlich auf Unterrichtseinheiten von 45 Minuten. Je nach Bedarf können auch längere Einheiten von beispielsweise 60 oder 90 Minuten vereinbart werden." },
      { q: "Wie oft sollte Nachhilfe stattfinden?", a: "Das hängt vom aktuellen Leistungsstand und vom Ziel ab. Häufig ist eine regelmäßige Einheit pro Woche sinnvoll. Bei größeren Wissenslücken oder vor Prüfungen können vorübergehend auch mehrere Einheiten pro Woche vereinbart werden." },
      { q: "Gibt es eine Mindestlaufzeit oder Vertragsbindung?", a: "Nein. Bei AvantiTutor gibt es keine langfristige Vertragsbindung. Die Nachhilfe soll sich flexibel an den tatsächlichen Bedarf des Schülers anpassen können." },
      { q: "Muss ich ein Abo abschließen?", a: "Nein. Bei AvantiTutor gibt es kein Abo-Modell. Es werden nur die Unterrichtseinheiten abgerechnet, die tatsächlich in Anspruch genommen wurden." },
      { q: "Wann wird die Nachhilfe abgerechnet?", a: "Die Abrechnung erfolgt am Ende des Monats. Berechnet werden grundsätzlich nur die Unterrichtseinheiten, die im jeweiligen Monat tatsächlich in Anspruch genommen wurden." },
      { q: "Wie setzen sich die Preise zusammen?", a: "Die Preise richten sich nach Klassenstufe beziehungsweise Niveau, Fach und Unterrichtsdauer. Alle Preise werden transparent auf unserer Website dargestellt." },
      { q: "Gibt es versteckte Gebühren?", a: "Nein. Unsere Preise werden transparent kommuniziert. Es gibt keine versteckten Mitglieds- oder Abogebühren." },
      { q: "Was passiert, wenn ein Termin abgesagt werden muss?", a: "Kein Problem. Wird ein Termin mindestens 24 Stunden vorher abgesagt, entstehen keine Kosten. Bei kurzfristigeren Absagen kann maximal eine Unterrichtseinheit von 45 Minuten berechnet werden." },
      { q: "Kann der Unterricht während der Ferien pausiert werden?", a: "Ja. Die Nachhilfe kann flexibel an Ferien, Urlaub oder andere Termine angepasst werden. Es müssen während einer Pause keine Unterrichtseinheiten gebucht werden." },
      { q: "Kann man die Anzahl der Stunden später erhöhen oder reduzieren?", a: "Ja. Die Anzahl und Dauer der Unterrichtseinheiten kann jederzeit an den aktuellen Bedarf angepasst werden – beispielsweise intensiver vor einer Prüfung oder weniger häufig, wenn sich die Leistungen stabilisiert haben." },
      { q: "Kann mein Kind auch nur für einige Wochen Nachhilfe nehmen?", a: "Ja. Nachhilfe kann sowohl langfristig als auch nur für einen bestimmten Zeitraum genutzt werden, beispielsweise zur Prüfungsvorbereitung oder um gezielt einzelne Wissenslücken aufzuarbeiten." },
      { q: "Wie kann ich mein Kind anmelden?", a: "Über unsere Website kann zunächst die kostenlose Bedarfsanalyse angefragt werden. Dort ermitteln wir den aktuellen Lernstand und den konkreten Unterstützungsbedarf. Anschließend kann direkt mit der Nachhilfe gestartet werden." },
    ],
  },
];

export const team = [
  {
    name: 'Dr. Lukas Bauer',
    role: 'Gründer & Didaktik-Lead',
    bio: 'Promovierter Mathematiker mit 10+ Jahren Erfahrung in individueller Förderung.',
    initials: 'LB',
    color: 'bg-teal-500',
  },
  {
    name: 'Mira Schneider',
    role: 'Sprachen & Abiturcoach',
    bio: 'Lehramt Deutsch/Englisch, spezialisiert auf Abiturvorbereitung & Textanalyse.',
    initials: 'MS',
    color: 'bg-pink-500',
  },
  {
    name: 'Tobias Winter',
    role: 'Naturwissenschaften',
    bio: 'Chemie-/Physik-Experte, liebt es, komplexe Themen verständlich zu machen.',
    initials: 'TW',
    color: 'bg-indigo-500',
  },
  {
    name: 'Ayla Demir',
    role: 'Online-Tutoring Lead',
    bio: 'Entwickelt moderne digitale Lernformate und betreut die Online-Community.',
    initials: 'AD',
    color: 'bg-amber-500',
  },
];

export const values = [
  { icon: 'Target', title: 'Klare Ziele', text: 'Jede Session hat ein messbares Lernziel – kein ziellose Zeit verbringen.' },
  { icon: 'HandHeart', title: 'Persönlich', text: 'Kein Massenbetrieb. Jeder Schüler bekommt einen festen Ansprechpartner.' },
  { icon: 'TrendingUp', title: 'Messbarer Erfolg', text: 'Transparente Fortschritts-Reports, nicht nur Bauchgefühl.' },
  { icon: 'Sparkles', title: 'Freude am Lernen', text: 'Wir glauben: Wer versteht, lernt freiwillig weiter.' },
];

// Features aus dem Flyer (Student-Sicht)
export const flyerStudentFeatures = [
  { icon: 'User',     title: '100 % INDIVIDUELL',   text: 'Nachhilfe, die zu dir passt.',           color: 'green' },
  { icon: 'Calendar', title: 'FLEXIBLE TERMINE',    text: 'Unterricht, wann es für dich passt.',    color: 'blue' },
  { icon: 'Euro',     title: 'FAIRE PREISE',        text: 'Transparente Preise. Ohne versteckte Kosten.', color: 'pink' },
  { icon: 'Ban',      title: 'KEIN ABO-MODELL',     text: 'Keine Vertragsbindung. Du bleibst flexibel.',  color: 'sky' },
];

// Features aus dem Flyer (Tutor-Recruiting)
export const flyerTutorFeatures = [
  { icon: 'Monitor',   title: 'ONLINE UNTERRICHTEN',       text: 'Unterrichte bequem von überall.',   color: 'green' },
  { icon: 'Clock',     title: 'FLEXIBLE ZEITEN',           text: 'Bestimme deine Zeiten selbst.',      color: 'blue' },
  { icon: 'BookOpen',  title: 'FÄCHER SELBST WÄHLEN',      text: 'Unterrichte, was du gut kannst.',    color: 'purple' },
  { icon: 'Laptop',    title: 'ALLES DIGITAL VORBEREITET', text: 'Materialien, Tools und Organisation – wir liefern alles.', color: 'orange' },
];

// Watercolor color mapping
export const wcColors = {
  green:  { bg: 'bg-emerald-100',  ring: 'ring-emerald-200',  text: 'text-emerald-600',  title: 'text-emerald-600'  },
  blue:   { bg: 'bg-sky-100',      ring: 'ring-sky-200',      text: 'text-sky-600',      title: 'text-sky-600'      },
  purple: { bg: 'bg-violet-100',   ring: 'ring-violet-200',   text: 'text-violet-600',   title: 'text-violet-600'   },
  orange: { bg: 'bg-orange-100',   ring: 'ring-orange-200',   text: 'text-orange-600',   title: 'text-orange-600'   },
  pink:   { bg: 'bg-rose-100',     ring: 'ring-rose-200',     text: 'text-rose-500',     title: 'text-rose-500'     },
  sky:    { bg: 'bg-slate-100',    ring: 'ring-slate-200',    text: 'text-slate-500',    title: 'text-slate-600'    },
};

export const HERO_IMG = 'https://images.pexels.com/photos/5934555/pexels-photo-5934555.jpeg';
export const ABOUT_IMG = 'https://images.unsplash.com/photo-1629359652978-a5d383151c4c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwyfHx0dXRvcmluZyUyMHN0dWRlbnRzfGVufDB8fHx8MTc3Nzg3NDY3OXww&ixlib=rb-4.1.0&q=85';
export const ONLINE_IMG = 'https://images.unsplash.com/photo-1588196749597-9ff075ee6b5b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwzfHxvbmxpbmUlMjBsZWFybmluZ3xlbnwwfHx8fDE3Nzc4NzQ2Nzl8MA&ixlib=rb-4.1.0&q=85';
export const TUTOR_IMG = 'https://images.unsplash.com/photo-1629360035258-2ccb13aa3679?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHw0fHx0dXRvcmluZyUyMHN0dWRlbnRzfGVufDB8fHx8MTc3Nzg3NDY3OXww&ixlib=rb-4.1.0&q=85';
